export const REQUEST_GET_ALL_CUSTOMERS = 'merchant/REQUEST_GET_ALL_CUSTOMERS';
export const RECEIVED_GET_ALL_CUSTOMERS = 'merchant/RECEIVED_GET_ALL_CUSTOMERS';
export const RECEIVED_ERROR = 'merchant/CUSTOMER_ERROR';
export const REQUEST_GET_PAGED_CUSTOMERS = 'task/REQUEST_GET_PAGED_CUSTOMERS';
export const RECEIVED_PAGED_CUSTOMERS = 'task/RECEIVED_PAGED_CUSTOMERS';
